export default __webpack_public_path__ + "static/arguably-the-best-face-masks-for-a-long-haul-flight-honey-ddc28ce16b8ef3d990955167ea2ddcba.jpg";